import { find, findAll } from "../utils/dom";

const PageInstitucional = () =>{
	const page = find(`[js-page='institucional']`);
	if(!page) return;


	const $ = {
		Informacao: findAll('[js-informacao]'),
		ModalInformacao: find(`[js-modal="institucional"]`)
	}


	$.Informacao?.forEach((info)=>{
		info.addEventListener("click", (e)=>{
			const modalInfo = {
				nome: $.ModalInformacao.querySelector("[js-nome-informacao]"),
				imagem: $.ModalInformacao.querySelector("[js-imagem-informacao]"),
				descricao: $.ModalInformacao.querySelector("[js-descricao-informacao]")
			}

			const atualInfo = {
				nome: e.target.getAttribute('js-nome'),
				imagem: e.target.getAttribute('js-foto'),
				descricao: e.target.getAttribute('js-descricao')
			}

			modalInfo.nome.innerText = atualInfo.nome;
			modalInfo.imagem.src = atualInfo.imagem;
			modalInfo.descricao.innerText = atualInfo.descricao

		})
	})
}

export default PageInstitucional;